'use client'

import Skeleton from './Skeleton'

export type { SkeletonProps } from './Skeleton'

export default Skeleton
